import GetGatheringForReactionAssetDocument from "src/api/graphql/__generated__/documents/GetGatheringForReactionAssetDocument";
import useGlobalRefreshListener from "./useGlobalRefreshListener";
import useRevalidatedQuery from "./useRevalidatedQuery";

const useGatheringReactionAsset = (gatheringId: string) => {
	const { data, loading, refetch } = useRevalidatedQuery(GetGatheringForReactionAssetDocument, {
		variables: {
			input: {
				gatheringId,
			},
		},
	});

	useGlobalRefreshListener(refetch);

	return {
		reactionAsset: data?.getGathering?.reactionAsset,
		loading,
	};
};
export default useGatheringReactionAsset;
